module.exports = __webpack_public_path__ + "static/img/伙伴客户-广东第二中医院.129841df.png";